import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { Router } from "@angular/router";
import { TAAConstants } from "../../constants/taa-constants";
import { AccommsService } from "../../services/accomms.service";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { DocumentService } from "../../services/document.service";
import { HeaderService } from "../../services/header.service";
import { PersonService } from "../../services/person.service";
import { PlanService } from "../../services/plan.service";
import { RequestSubmitService } from "../../services/requestsubmit.service";
import { User } from "../../services/user.model";
import { StepperComponent } from "../stepper/stepper.component";

@Component({
  selector: "app-documentation",
  templateUrl: "./documentation.component.html",
  styleUrls: ["./documentation.component.css"]
})
export class DocumentationComponent implements OnInit {
  public successMessage: string;
  public errorMessage: string;
  public personName: string;
  public personId: string;
  public requetId: string;
  public taaPin: string;
  public noOfErrors: number;
  public currentRecord: any;
  public documents: any = [];
  public supportedFileSize: any;
  public supportedFileSizeMB: any;
  public supportedFileTypes: string;
  public supportedFileLength: string;
  public fetchGuidelinesLink: string;
  public errorMessageFlag: boolean;
  public sameDocErrFlag: boolean;
  public emptyDocErrFlag: boolean;
  public deletedDocFlag: boolean;
  public fileExits: boolean;
  public statusCode: any;
  public showContinue = false;
  public submitStatusCd: any;
  public apiCount: number = 0;
  public isLoading: boolean = false;
  public docReconsideration: string;
  public userProfile: User;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public clickOnce: boolean;
  public mdmId: string;
  public selectedOrg: any;
  public recordCount = "0";
  @ViewChild('openModal') openModal: ElementRef;

  constructor(
    public stepper: StepperComponent,
    private _loggerService: LoggerService,
    public router: Router,
    private headerService: HeaderService,
    private appService: AppService,
    private documentService: DocumentService,
    private personService: PersonService,
    public accommsService: AccommsService,
    public taaConstants: TAAConstants,
    public requestSubmitService: RequestSubmitService,
    public commonService: CommonService,
    public planService: PlanService
  ) { }

  ngOnInit() {
    this.clickOnce = false;
    sessionStorage.setItem("accomSubmitted", "");
    this.isLoading = true;
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    this.selectedOrg = this.headerService.getselectedOrgDetails();
    this.mdmId = this.selectedOrg.mdmId;
    Observable.forkJoin(
      this.commonService.getFinishedRecordCount(this.currentRecord.personId),
      this.commonService.getDynContent(
        "REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG"
      )
    ).subscribe(([finishedRecordCount, docReconsideration]) => {
      if (finishedRecordCount === "1") {
        this.recordCount = "1";
      } else if (finishedRecordCount === "error") {
        this.openModal.nativeElement.click();
      }
      // this.recordCount = finishedRecordCount as any;
      this.docReconsideration = docReconsideration;
      this.appService.getUserProfile().then(user => (this.userProfile = user));
    });
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.currentRecord = studentDetails;
      this.personId = this.currentRecord.personId;
      this.requetId = this.currentRecord.requestId;
    } else {
      this.currentRecord = this.stepper.getPreviousRecordDetails();
      this.personId = this.currentRecord.personId;
      this.requetId = this.currentRecord.requestId;
    }
    this.headerService.getSystemProperties().then(properties => {
      this.supportedFileSize =
        properties["DOCUMENTATION_MAX_UPLOAD_SIZE_HEADER"];
      this.supportedFileSizeMB = this.formatFileSize(this.supportedFileSize, 0);
      this.supportedFileTypes =
        properties["DOCUMENTATION_SUPPORTED_FILE_TYPES"];
      this.supportedFileLength =
        properties["DOCUMENTATION_MAX_UPLOAD_FILE_NM_LENGTH_HEADER"];
      this.fetchGuidelinesLink =
        properties["SYSTEM_KEY_ACCOMM_GUIDELINES_LINK"];
    });

    this.errorMessage = "";
    this.personName = this.currentRecord.personName;
    this.taaPin = this.currentRecord.taaPin;
    this.built();
  }
  gotoHome() {
    setTimeout(() => {
      this.router.navigate(["/examinees"]);
    }, 500);
  }
  built() {
    this.documentService
      .getDocuments(this.currentRecord.personId, this.currentRecord.requestId, this.mdmId)
      .subscribe(response => {
        var docs: any[] = <Array<any>>response;
        this.planService.getPersonPlanById(this.currentRecord.personId).subscribe(
          planResponse => {
            const personPlan: any = planResponse.body;
            this.planService.getPlanById(personPlan.planId).subscribe(
              planDetailsResponse => {

                const planDetails: any = planDetailsResponse;
                if (planDetails.PLAN_NM === 'IEP') {

                  docs = docs.filter(a => {
                    a.DOCUMENT_TYPE_NM = 'I';
                  })

                }
                docs.sort((a, b) => {
                  return a.DISPLAY_ORDER_NO - b.DISPLAY_ORDER_NO;
                });
                for (let i = 0; i < docs.length; i++) {
                  this.apiCount = docs.length - 1;
                  setTimeout(
                    count => {
                      this.documents[count] = {};
                      this.documents[count].fileList = [];
                      this.documents[count].docType = [];
                      Observable.forkJoin(
                        this.documentService.getUplodedDocuments(
                          this.currentRecord.personId,
                          docs[count].DOCUMENT_TYPE_ID
                        )
                      )
                        .finally(() => {
                          if (this.apiCount === count) {
                            this.isLoading = false;
                          }
                        })
                        .subscribe(([uploadedFiles]) => {
                          const fileList: any = uploadedFiles;
                          if (uploadedFiles) {
                            if (fileList.length !== 0) {
                              this.documents[count].fileList = fileList;
                            }
                            if (docs[count]["DOCUMENT_TYPE_DS"]) {
                              docs[count].uploadFlag = false;
                              docs[count].errorMessageFlag = false;
                              docs[count].errorMessage = "";
                              this.documents[count].docType = docs[i];
                            }
                          }
                        });
                    },
                    true,
                    i
                  );
                }
              })
          }
        )
      });
  }
  formatFileSize(bytes, decimalPoint) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      Math.floor(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))) +
      " " +
      sizes[i]
    );
  }

  fileChange = (event, item) => {
    item.file = event.target.files[0];
  }

  saveDocumentationData = () => {
    let validationFlag = false;
    this.noOfErrors = 0;
    this.documents.forEach(item => {
      if (
        item.fileList.length === 0 &&
        item.docType.DOCUMENT_TYPE_DS !== "Other Documentation"
      ) {
        this.noOfErrors += 1;
        item.errorMessageFlag = true;
        item.errorMessage = item.docType.DOCUMENT_TYPE_DS + " is required";
        this.deletedDocFlag = false;
        this.successMessage = "";
        validationFlag = true;
        item.displayError = true;
        this.fileExits = true;
      } else {
        item.errorMessageFlag = false;
      }
    });
    if (!validationFlag) {
      const updateRequestFromDocument = {
        PERSON_ID: this.currentRecord.personId,
        REQUEST_ID: this.currentRecord.requestId,
        REQUEST_STATE_TX: "6",
        UPDATED_BY_DS: this.currentRecord.userName
      };

      Observable.forkJoin(
        this.documentService.updateRequestForDocument(
          updateRequestFromDocument
        ),
        this.requestSubmitService.getRequestStatusCodeIdByNm(
          this.taaConstants.getRECONSIDER_INCOMPLETE()
        )
      ).subscribe(
        success => {
          if (
            this.statusCode === this.taaConstants.getRECONSIDER_INCOMPLETE()
          ) {
            this.auditStatusText = "Request updated on Documentation Page ";
            this.auditLogCategory = "REQUEST_CHANGE";
            this.updateLogs();
          }
          sessionStorage.setItem("docSubmitted", "true");
          this.stepper.goToNextStep();
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.errorMessageFlag = true;
      return;
    }
  }

  uploadFile = (item: any) => {
    this.clickOnce = true;
    if (typeof item.file === "undefined") {
      this.noOfErrors = 1;
      this.errorMessage = "Please select a valid file.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.emptyDocErrFlag = false;
      this.deletedDocFlag = false;
      this.clickOnce = false;
      return;
    }
    const fileExtension = require("file-extension");
    const fileExt = fileExtension(item.file.name);
    const fileSize = item.file.size;
    const fileName = item.file.name
      .split(".")
      .slice(0, -1)
      .join("."),
      acceptableFileTypes = ["pdf", "doc", "docx", "txt"];
    const alphanumeric = /^[a-zA-Z0-9]+$/;

    if (item.file.name.length >= this.supportedFileLength || !alphanumeric.test(fileName)) {
      this.noOfErrors = 1;
      this.errorMessage = !alphanumeric.test(fileName)
        ? "The file name cannot contain spaces or special characters."
        : "The file name cannot be more than " + this.supportedFileLength + " characters.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.deletedDocFlag = false;
      this.emptyDocErrFlag = false;
      this.clickOnce = false;
      return;
    }

    if (fileSize > this.supportedFileSize) {
      this.noOfErrors = 1;
      this.errorMessage =
        "The upload file size cannot be more than " +
        this.supportedFileSizeMB +
        ". You can try to split the document into multiple parts and upload them separately or check with your IT staff if you need further assistance with decreasing the file size.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.deletedDocFlag = false;
      this.emptyDocErrFlag = false;
      this.clickOnce = false;
      return;
    }

    let validExt = false;
    acceptableFileTypes.forEach(function (ext) {
      if (fileExt === ext) {
        validExt = true;
      }
    });

    if (!validExt) {
      this.noOfErrors = 1;
      this.errorMessage =
        "Please select a valid file. File must be in " +
        acceptableFileTypes +
        " format.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.emptyDocErrFlag = false;
      this.sameDocErrFlag = false;
      this.deletedDocFlag = false;
      this.clickOnce = false;
      return;
    }

    if (item.file) {
      this.personService
        .uploadFile(
          item.file,
          item.docType.DOCUMENT_TYPE_DS,
          item.docType.DOCUMENT_TYPE_ID
        )
        .subscribe(result => {
          const res: any = result;
          if (
            res.status === 200 &&
            res.body.status === "Similar document exists"
          ) {
            this.errorMessageFlag = false;
            this.emptyDocErrFlag = false;
            this.successMessage = "";
            this.sameDocErrFlag = true;
            this.deletedDocFlag = false;
            this.clickOnce = false;
          }
          if (
            res.status === 200 &&
            res.body.status === "Uploaded sucessfully"
          ) {
            this.sameDocErrFlag = false;
            this.emptyDocErrFlag = false;
            this.successMessage = "File uploaded successfully";
            item.uploadFlag = true;
            this.errorMessageFlag = false;
            this.deletedDocFlag = false;
            this.clickOnce = false;
            this.built();
            return;
          }
        });
    }
  }

  downloadFile = (event, item: any) => {
    this.errorMessageFlag = false;
    this.emptyDocErrFlag = false;
    this.sameDocErrFlag = false;
    this.successMessage = "";
    this.deletedDocFlag = false;
    this.personService.downloadFile(item.FILE_NM);

    event.stopPropagation();
    event.preventDefault();
  }

  deleteFile = (event, item: any) => {
    if (window.confirm("Are you sure you want to delete the document ?")) {
      this.personService.deleteFile(item).subscribe(result => {
        const res: any = result;
        if (res.status === 200 && res.body.status === "Deleted sucessfully") {
          this.errorMessageFlag = false;
          this.emptyDocErrFlag = false;
          this.sameDocErrFlag = false;
          this.successMessage = "";
          this.deletedDocFlag = true;
          this.built();
        }
      });
    }

    event.stopPropagation();
    event.preventDefault();
  }

  goToAccomms = () => {
    this.stepper.goToPrevStep();
  }

  continueToNext = () => {
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getRECONSIDER_INCOMPLETE()
      )
    ).subscribe(([submitStatus]) => {
      this.submitStatusCd = submitStatus[0].REQUEST_STATUS_CODE_ID;
      const updateRequest = {
        PERSON_ID: this.currentRecord.personId,
        REQUEST_ID: this.currentRecord.requestId,
        REQUEST_STATUS_CODE_ID: this.submitStatusCd,
        REQUEST_STATE_TX: "6",
        UPDATED_BY_DS: this.currentRecord.userName
      };
      this.auditStatusText =
        "Request updated on Documentation Page from Complete to ReconsiderIncomplete ";
      this.auditLogCategory = "STATUS_CHANGE";
      this.updateLogs();

      Observable.forkJoin(
        this.commonService.updateRequestForReconsider(updateRequest)
      ).subscribe(
        success => {
          sessionStorage.setItem("docSubmitted", "true");
          this.stepper.goToNextStep();
        },
        err => {
          console.log(err);
        }
      );
    });
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.auditLogCategory,
      COMPONENT_ID: "REQUEST_DOCUMENT_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: this.auditStatusText,
      REFERENCE_ID: this.stepper.request.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL: this.userProfile.userName
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/request/documentation/documentation.component.ts